import { createFileRoute } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { PageHeader } from '@/components/common/PageHeader';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useAuthStore } from '@/lib/auth-store';
import { UsersTab } from '@/components/settings/UsersTab';
import { TokensTab } from '@/components/settings/TokensTab';
import { IntegrationsTab } from '@/components/settings/IntegrationsTab';
import { TenantTab } from '@/components/settings/TenantTab';

export const Route = createFileRoute('/_auth/settings')({
  component: SettingsScreen,
});

function SettingsScreen() {
  const user = useAuthStore((s) => s.user);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <PageHeader title="Configuración" icon={Settings} description="Usuarios, tokens API, integraciones y tenant" />

      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-3">
        <Tabs defaultValue="users" className="flex flex-col h-full">
          <TabsList className="shrink-0 h-8 w-auto self-start gap-0.5">
            <TabsTrigger value="users" className="text-xs px-3">Usuarios & RBAC</TabsTrigger>
            <TabsTrigger value="tokens" className="text-xs px-3">Tokens API</TabsTrigger>
            <TabsTrigger value="integrations" className="text-xs px-3">Integraciones</TabsTrigger>
            <TabsTrigger value="tenant" className="text-xs px-3">Tenant</TabsTrigger>
          </TabsList>

          <TabsContent value="users" className="flex-1 min-h-0 mt-3">
            <UsersTab />
          </TabsContent>

          <TabsContent value="tokens" className="flex-1 min-h-0 mt-3">
            <TokensTab />
          </TabsContent>

          <TabsContent value="integrations" className="flex-1 min-h-0 mt-3 overflow-y-auto">
            <IntegrationsTab />
          </TabsContent>

          <TabsContent value="tenant" className="flex-1 min-h-0 mt-3 overflow-y-auto">
            <TenantTab user={user} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
